import { query_product_in_record_2_list } from '@/api/mjstock-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/mjstock/mjstock-productinrecord2-config';

import { reactive } from 'vue';
import { get_is_active, getDate, getDateTime, toFixed0 } from '@/utils/function';

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

const search_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'input',
      name: 'code',
      label: '单据编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写单据编号',
    },
    {
      type: 'remotemodal',
      name: 's_product_id',
      label: '产品',
      disabled: false,
      placeholder: '请选择产品',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstock-sproduct',
    },
    {
      type: 'input',
      name: 'product_code',
      label: '产品批次号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写产品批次号',
    },
    {
      type: 'input',
      name: 'position',
      label: '库位',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写库位',
    },
    {
      type: 'rangepicker',
      name: 'end_date',
      label: '到期日期',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      showTime: false,
      placeholder: '请填写到期日期',
    },
    {
      type: 'remotemodal',
      name: 'from_shop_id',
      label: '调拨来源',
      disabled: false,
      placeholder: '请选择调拨来源',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-shop',
    },
    {
      type: 'input',
      name: 'transfer_code',
      label: '调拨编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写调拨编号',
    },
    {
      type: 'remoteselect',
      name: 'shop_id',
      label: '执行门店',
      disabled: false,
      placeholder: '请选择执行门店',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-shop',
    },
    {
      type: 'remoteselect',
      name: 'staff_id',
      label: '执行人',
      disabled: false,
      placeholder: '请选择执行人',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-staff',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,

    code: null,
    s_product_id: null,
    in_type: null,
    product_code: null,
    position: null,
    end_date: null,
    from_shop_id: null,
    transfer_code: null,
    shop_id: null,
    staff_id: null,
  }),
};
const search_options = {
  in_type: [
    { value: None, name: '全部' },
    { value: 1, name: '采购入库' },
    { value: 2, name: '盘盈入库' },
    { value: 3, name: '调拨入库' },
    { value: 4, name: '其他入库' },
  ],
  is_active: [
    { value: None, name: '全部' },
    { value: True, name: '可用' },
    { value: False, name: '作废' },
  ],
};

const edit_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
  },
  fields: [],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
  }),
};
const edit_model_config_options = {};

const update_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
  },
  fields: [],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
  }),
};
const update_model_config_options = {};

const titleList = {
  title: '产品入库记录管理',
  addModalTitle: '新建产品入库记录',
  updateTitle: '修改产品入库记录',
  is_create: false, // 是否有【新建】按钮
  is_update: false, // 是否有【修改】按钮
  is_remove: false, // 是否有【删除】按钮
  is_recover: false, // 是否有【恢复】按钮
};

const api_fields: Record = {
  update: {
    id: 'id',
  },
  delete: {
    id: 'id',
  },
  recover: {
    id: 'id',
  },
  updateData: {
    org_id: 'org_id',
    id: 'id',
  },
};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
    fixed: 'left',
  },
  {
    title: '单据编号',
    width: 150,
    dataIndex: 'code',
    fixed: 'left',
    checked: true,
  },
  {
    title: 'ID',
    width: 150,
    dataIndex: 'id',
    checked: false,
  },
  {
    title: '入库类型',
    width: 150,
    dataIndex: 'in_type',
    checked: true,
    content: (record: any, text: any) => {
      let content = '';
      switch (text) {
        case 1:
          content = '采购入库';
          break;
        case 2:
          content = '盘盈入库';
          break;
        case 3:
          content = '调拨入库';
          break;
        case 4:
          content = '其他入库';
          break;
        default:
          content = '';
          break;
      }
      return content;
    },
    filterMultiple: true,
    filters: [
      { text: '全部', value: '' },
      { text: '采购入库', value: '1' },
      { text: '盘盈入库', value: '2' },
      { text: '调拨入库', value: '3' },
      { text: '其他入库', value: '4' },
    ],
  },
  {
    title: '产品ID',
    width: 150,
    dataIndex: 's_product_id',
    checked: false,
  },
  {
    title: '产品名称',
    width: 150,
    dataIndex: 's_product__name',
    checked: true,
  },
  {
    title: '产品编码',
    width: 150,
    dataIndex: 's_product__code',
    checked: true,
  },
  {
    title: '产品批次号',
    width: 150,
    dataIndex: 'product_code',
    checked: true,
  },
  {
    title: '库位',
    width: 150,
    dataIndex: 'position',
    checked: true,
  },
  {
    title: '入库数量',
    width: 150,
    dataIndex: 'in_num',
    checked: true,
  },
  {
    title: '商品单价',
    width: 150,
    dataIndex: 'single_price',
    checked: true,
    content: (record: any, text: any) => {
      return toFixed0(text);
    },
  },
  {
    title: '商品总价',
    width: 150,
    dataIndex: 'price',
    checked: true,
  },
  {
    title: '生产日期',
    width: 150,
    dataIndex: 'product_date',
    checked: true,

    content: (record: any, text: any) => {
      return getDate(text);
    },
  },
  {
    title: '到期日期',
    width: 150,
    dataIndex: 'end_date',
    checked: true,

    content: (record: any, text: any) => {
      return getDate(text);
    },
  },
  {
    title: '调拨门店ID',
    width: 150,
    dataIndex: 'from_shop_id',
    checked: false,
  },
  {
    title: '门店名称',
    width: 150,
    dataIndex: 'from_shop__name',
    checked: true,
  },
  {
    title: '唯一标记',
    width: 150,
    dataIndex: 'from_shop__code',
    checked: true,
  },
  {
    title: '调拨编号',
    width: 150,
    dataIndex: 'transfer_code',
    checked: true,
  },
  {
    title: '入库时间',
    width: 150,
    dataIndex: 'in_datetime',
    checked: true,

    content: (record: any, text: any) => {
      return getDate(text);
    },
  },
  {
    title: '执行门店ID',
    width: 150,
    dataIndex: 'shop_id',
    checked: false,
  },
  {
    title: '门店名称',
    width: 150,
    dataIndex: 'shop__name',
    checked: true,
  },
  {
    title: '执行人ID',
    width: 150,
    dataIndex: 'staff_id',
    checked: false,
  },
  {
    title: '员工姓名',
    width: 150,
    dataIndex: 'staff__name',
    checked: true,
  },
  {
    title: '创建日期',
    width: 150,
    dataIndex: 'create_time',
    checked: true,

    content: (record: any, text: any) => {
      return getDateTime(text);
    },
  },
  {
    title: '更新时间',
    width: 150,
    dataIndex: 'update_time',
    checked: true,

    content: (record: any, text: any) => {
      return getDateTime(text);
    },
  },
  {
    title: '是否可用',
    width: 150,
    dataIndex: 'is_active',
    checked: true,

    cellComponent: 'boolean',
    name1: '可用',
    name2: '禁用',
    filterMultiple: false,
    filters: [
      { text: '全部', value: '' },
      { text: '可用', value: true },
      { text: '作废', value: false },
    ],
    content: (record: any, text: any) => {
      return get_is_active(text);
    },
  },

  {
    title: '操作',
    width: 250,
    dataIndex: 'action',
    checked: true,
    cellComponent: 'action',
    fixed: 'right',
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);
newSlotList.push(
  {
    type: 'custom',
    slotName: 'in_type',
    field_1: '采购入库',
    field_2: '盘盈入库',
    field_3: '调拨入库',
    field_4: '其他入库',
  },
  { type: 'custom', slotName: 'is_active', field_true: '可用', field_false: '作废' },
);

export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_product_in_record_2_list,
    addData: None,
    updateData: None,
    removeData: None,
    recoverData: None,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
